export const SERVICES = [
  {
    id: "cv-writing",
    name: "Professional CV Writing",
    price: 77,
    description: "Turn your work history into a high-converting British standard CV.",
    turnaround: "10 days basic · 3–5 days advanced",
    features: [
      "100% compliant UK layout (strict 2-page golden rule, no photos)",
      "Comprehensive ATS keyword optimisation",
      "Compelling professional summary written through a UK recruiter's lens",
      "Delivered in editable MS Word and PDF formats",
      "2 rounds of revisions included",
    ],
  },
  {
    id: "cover-letter",
    name: "High-Impact Cover Letter",
    price: 41.8,
    description: "A tailored, persuasive letter designed to make UK recruiters read your CV.",
    turnaround: "10 days basic · 3–5 days advanced",
    features: [
      "Modular, easy-to-customise layout for different target roles",
      "Clear hook openings that align with British corporate expectations",
      "Sharp articulation of your unique value proposition",
    ],
  },
  {
    id: "linkedin-optimization",
    name: "LinkedIn Profile Optimization",
    price: 60.5,
    description: "Align your digital presence to draw passive recruiters and headhunters straight to you.",
    turnaround: "10 days basic · 3–5 days advanced",
    features: [
      "Keyword-dense headline rewrite to boost UK search visibility",
      "Engaging About section written in a professional, narrative first-person style",
      "Strategic guidance on location and open-to-work settings for the UK market",
    ],
  },
  {
    id: "job-search-assistance",
    name: "UK Job Search Assistance",
    price: 89.1,
    description: "Stop wasting time applying blindly. Get a blueprint on how hiring actually works in Britain.",
    turnaround: "10 days basic · 3–5 days advanced",
    features: [
      "Curated directory of top UK job boards tailored to your industry",
      "Inside track on bypassing algorithms via UK recruitment agencies",
      "Custom strategy for automated, high-yielding job alerts",
    ],
  },
  {
    id: "interview-prep",
    name: "1-on-1 Interview Preparation",
    price: 107.8,
    description: "Pass your screening calls and final panels with live coaching from a UK HR professional.",
    turnaround: "60-min session · booked on GMT",
    features: [
      "60-minute virtual intensive interview simulation",
      "Masterclass on the STAR methodology preferred by UK firms",
      "Immediate, candid feedback on tone, structure and competency answers",
    ],
  },
  {
    id: "ultimate-bundle",
    name: "The Ultimate UK Career Bundle",
    price: 236.5,
    originalValue: 376.2,
    savings: "Save £139.70",
    popular: true,
    description: "The all-in-one corporate launchpad for job seekers securing a footprint in the UK market.",
    turnaround: "10 days basic · 3–5 days advanced",
    features: [
      "Professional ATS-optimised CV",
      "High-impact Cover Letter",
      "Full LinkedIn Profile Optimization",
      "Comprehensive UK Job Search Guide",
      "Priority email support throughout the process",
    ],
  },
];

export const ORDER_STEPS = [
  { id: "awaiting_payment", label: "Awaiting Payment" },
  { id: "received", label: "Order Received" },
  { id: "questionnaire_received", label: "Questionnaire Received" },
  { id: "hr_review", label: "HR Executive Review" },
  { id: "draft_ready", label: "Draft Ready" },
  { id: "completed", label: "Completed" },
];

export const getService = (id) => SERVICES.find((s) => s.id === id);

export const DELIVERY_OPTIONS = {
  basic: { id: "basic", label: "Basic Delivery", days: "10 working days", fee: 0 },
  advanced: { id: "advanced", label: "Advanced Priority", days: "3–5 working days", fee: 25 },
};

export const gbp = (n) => `£${Number(n).toFixed(2)}`;
